(() => {
  const reveals = [...document.querySelectorAll('.reveal')];

  // Each element fires as soon as it enters the viewport activation zone.
  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, {
    root: null,
    threshold: 0,
    rootMargin: '0px 0px -6% 0px'
  });

  reveals.forEach((el) => revealObserver.observe(el));

  // Hero is already in the viewport on load, so start it immediately.
  requestAnimationFrame(() => {
    document.querySelectorAll('.hero .reveal').forEach((el) => {
      el.classList.add('is-visible');
      revealObserver.unobserve(el);
    });
  });

  // Safety check for elements already inside the activation zone at startup.
  const revealVisibleOnLoad = () => {
    const triggerY = window.innerHeight * 0.94;
    reveals.forEach((el) => {
      if (el.classList.contains('is-visible')) return;
      const rect = el.getBoundingClientRect();
      if (rect.top < triggerY && rect.bottom > 0) {
        el.classList.add('is-visible');
        revealObserver.unobserve(el);
      }
    });
  };
  requestAnimationFrame(revealVisibleOnLoad);

  // Restrained parallax for editorial scene images.
  const parallax = [...document.querySelectorAll('.scene img')];
  let ticking = false;
  const update = () => {
    const vh = innerHeight;
    parallax.forEach((img) => {
      const r = img.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      const progress = (r.top + r.height / 2 - vh / 2) / vh;
      img.style.transform = `translate3d(0, ${progress * -12}px, 0) scale(1.025)`;
    });
    ticking = false;
  };
  addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });
  update();
})();

